const matchesOrContains = (element, selector) =>
  element.matches(selector) ? element : element.querySelector(selector);

export default matchesOrContains;
